module.exports = __webpack_public_path__ + "img/pavlova.2980b766.jpg";